import React, { Component } from 'react';

import { Button } from "~/js/partials";

class OfferTile extends Component {

    state = {
        logo: null,
        tileImage: null
    }

    constructor(){
        super();
    }

    componentDidMount(){

        const offer = this.props.data['offer-details'];
        if(!this.state.tileImage){
            const id = offer['tile-image'] ? offer['tile-image'] : false;
            fetch(`/api/v1/image/${id}/large`)
            .then((res) => res.json())
            .then((data) => {
                this.setState({
                    tileImage: data[0]
                }, function () {
                })
            })
            .catch((err) => console.log(err))
        }

        if(!this.state.logo){

            const logo = offer['brand'] ? offer['brand'][0].data['brand-details']['logo-colour'] : false;

            fetch(`/api/v1/image/${logo}/offer_logo`)
                .then((res) => res.json())
                .then((data) => {

                    this.setState({
                        logo: data[0]
                    }, function () {
                    })
                })
                .catch((err) => console.log(err))

            }
    }

    render() {
        const offer = this.props.data['offer-details'];

        const src = offer['tile-image'] ? offer['tile-image'] : false;
        const h = this.props.post_title;

        const url = `/offer/${this.props.post_name}`;

        const bgStyle = this.state.tileImage ? {backgroundImage: `url(${this.state.tileImage})`} : null;

        return (
            <div className={`offer-tile`}>
                <a href={url} className="offer-tile__image" style={bgStyle ?? null}></a>
                <div className="offer-tile__content">
                    <div className="row">
                        <div className="col-9">
                            <a href={url} className="offer-tile__h">{h}</a>
                        </div>
                        <div className="col-3">
                            <div className="offer-tile__logo">
                                { this.state.logo ? <img src={this.state.logo} /> : <img className="offer-tile__armstrongs-logo" src="/images/logo-black.svg" />  }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="offer-tile__cta">
                    <Button
                        title={offer['button-text'] ? offer['button-text'] :`Explore`}
                        modifiers={['text', 'black']}
                        href={url}
                        chevron={true}
                    />
                </div>
            </div>
        );
    }
}

export { OfferTile };
